import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import DownloadPage from "../pages/download/page";
import TermsOfService from "../pages/terms/page";
import PrivacyPolicy from "../pages/privacy/page";
import Contact from "../pages/contact/page";
import Questionnaire from "../pages/questionnaire/page";
import OpenApp from "../pages/open/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/download",
    element: <DownloadPage />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfService />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/questionnaire",
    element: <Questionnaire />,
  },
  {
    path: "/open",
    element: <OpenApp />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
